import * as React from "react";
import Home from "./view/home";
import "./App.css";
import RequirementForm from "Components/Form";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
